import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a2baaf1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notifications-option" }
const _hoisted_2 = { class: "notifications-option__text" }
const _hoisted_3 = { class: "notifications-option__title" }
const _hoisted_4 = { class: "notifications-option__subtitle" }

import { computed } from 'vue'

import { PublicInterface } from '@/models/interfaces'
import { QuestionnaireView } from '@/models/onboarding'
import {
  NotificationsChoice,
  QuestionnaireNotificationsOption,
} from '@/models/onboarding.types'

import ToggleButton from '@/components/ui/ToggleButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationsOption',
  props: {
    option: null,
    view: null
  },
  setup(__props: any) {

const props = __props as {
  option: QuestionnaireNotificationsOption
  view: PublicInterface<QuestionnaireView>
};



const currentChoice = computed(() => {
  return props.view.currentChoice as NotificationsChoice
})

function updateChoices(isChecked: boolean): void {
  const newValue = [...currentChoice.value]

  if (isChecked) {
    newValue.push(props.option.title)
  } else {
    const index = newValue.indexOf(props.option.title)
    if (index !== -1) {
      newValue.splice(index, 1)
    }
  }

  props.view.setCurrentChoice(newValue)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(__props.option.title), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(__props.option.subtitle), 1)
    ]),
    _createVNode(ToggleButton, {
      class: "notifications-option__input",
      value: _unref(currentChoice)?.includes(__props.option.title) || false,
      type: "checkbox",
      "onUpdate:value": updateChoices
    }, null, 8, ["value"])
  ]))
}
}

})